import axios from "axios";
import TokenService from "./token.service";

const instance = axios.create({
  baseURL: "https://fusion2.ornico.co.za",
  //baseURL: "https://stageapi.ornico.co.za",
  //baseURL: "http://localhost:3000",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "f3b96835356f78b4b3713466ee6dbe05"
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== "/auth/signin" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instance.post("/users/refresh_token", {
            userId: TokenService.getUser().userId,
            refreshToken: TokenService.getLocalRefreshToken(),
          });

          TokenService.updateLocalAccessToken(rs.data);

          return instance(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
